var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNexer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 903 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    fill: "#ffffff"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "path-1",
    points: "0 0.0111455108 902.272446 0.0111455108 902.272446 199.962848 0 199.962848",
    fill: "#ffffff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Nexer_Logo_Black_RGB"
  }, /*#__PURE__*/React.createElement("mask", {
    fill: "#ffffff",
    id: "mask-2"
  }, /*#__PURE__*/React.createElement("use", {
    href: "#path-1",
    fill: "#ffffff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Clip-2"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "nexer-logo-style",
    fill: "#ffffff",
    mask: "url(#mask-2)",
    points: "130.071207 192.693498 58.8965944 0.0111455108 0 0.0111455108 0 199.999381 29.8297214 199.999381 29.8297214 7.38018576 100.980805 199.999381 159.900929 199.999381 159.900929 0.0111455108 130.071207 0.0111455108 130.071207 192.693498"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "nexer-logo-style",
    fill: "#ffffff",
    mask: "url(#mask-2)",
    points: "543.147988 0.0111455108 490.593808 73.7275542 438.039628 0.0111455108 400.534365 0.0111455108 471.841486 100.031579 400.572136 199.999381 438.077399 199.999381 490.593808 126.335604 543.110217 199.999381 580.616099 199.999381 509.346749 100.031579 580.653251 0.0111455108 543.147988 0.0111455108"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "nexer-logo-style",
    fill: "#ffffff",
    mask: "url(#mask-2)",
    points: "368.983282 0.0111455108 331.478019 0.0111455108 402.78452 100.031579 331.51517 199.999381 369.021053 199.999381 440.290402 100.031579 368.983282 0.0111455108"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "nexer-logo-style",
    fill: "#ffffff",
    mask: "url(#mask-2)",
    points: "189.56161 199.999381 321.032198 199.999381 321.032198 171.478638 219.5387 171.478638 219.5387 114.265635 315.293498 114.265635 315.293498 85.7448916 219.5387 85.7448916 219.5387 28.6179567 321.032198 28.6179567 321.032198 0.0111455108 189.56161 0.0111455108 189.56161 199.999381"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "nexer-logo-style",
    fill: "#ffffff",
    mask: "url(#mask-2)",
    points: "591.121362 199.999381 722.594427 199.999381 722.594427 171.478638 621.095975 171.478638 621.095975 114.265635 716.854489 114.265635 716.854489 85.7448916 621.095975 85.7448916 621.095975 28.6179567 722.594427 28.6179567 722.594427 0.0111455108 591.121362 0.0111455108 591.121362 199.999381"
  }), /*#__PURE__*/React.createElement("path", {
    className: "nexer-logo-style",
    d: "M777.226006,85.7448916 L777.226006,28.6179567 L835.49226,28.6179567 C855.182663,28.6179567 869.888545,39.0705882 869.888545,57.3027864 C869.888545,75.5343653 855.182663,85.7448916 835.49226,85.7448916 L777.226006,85.7448916 Z M841.20743,114.186997 C874.315789,112.539319 900,91.6439628 900,57.1585139 C900,20.9380805 872.092879,0.0111455108 836.947368,0.0111455108 L747.399381,0.0111455108 L747.399381,200 L777.226006,200 L777.226006,114.305263 L803.770898,114.305263 L864.755418,200 L902.272446,200 L841.20743,114.186997 L841.20743,114.186997 Z",
    fill: "#ffffff",
    id: "Fill-7",
    mask: "url(#mask-2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNexer);
export default __webpack_public_path__ + "static/media/Nexer.18d00172bacb4664d8301e8fc36e5c9c.svg";
export { ForwardRef as ReactComponent };